module.exports = __webpack_public_path__ + "static/img/a7.377fc0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/founderIntr/img/en/a7.png
// module id = 3cLg
// module chunks = 5